import { defineMessages } from '@sm/intl';

const FORMS = 'GROW-2529';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2529';
const FORM_DETAILS_TOOLTIPS = 'form details tooltips';
const NUM_SURVEYS_FORMS = 'Number of surveys and forms';
const NUM_SURVEYS_FORMS_TOOLTIP =
  'You can create and send as many surveys, polls, and quizzes as you need with any plan.';
const QUESTIONS_PER_SURVEY_FORMS = 'Questions per survey/fields per form';
const QUESTIONS_PER_SURVEY_FORMS_TOOLTIP =
  'You can add unlimited questions to a survey and unlimited fields to a form with any paid plan.';
const SENTIMENT_ANALYSIS = 'Sentiment analysis';
const SENTIMENT_ANALYSIS_TOOLTIP = `We'll automatically label your text responses as positive, neutral, or negative to reveal the emotion behind what people are saying.`;
const SUPPORT_TOOLTIP =
  'We offer 24/7 email support for all customers. Emails from ADVANTAGE and PREMIER customers are prioritized to receive responses as quickly as possible. We also offer phone support for our PREMIER customers.';
const QUESTION_TYPES = 'Question types';
const QUESTION_TYPES_TOOLTIP = `Pick from 25+ question types to ensure you get exactly the information you need. With the forms plan you'll have what you need to collect contact information, online orders, and more.`;
const FILTER_COMPARE = 'Filter & compare results';

const experimentTooltipCopy = defineMessages({
  grow_2529_unlimited_forms_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.CreateSurveyLimitTooltip',
    defaultMessage: NUM_SURVEYS_FORMS,
    desc: {
      id: 'Pricing.experimentTooltipCopy.CreateSurveyLimitTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_unlimited_forms_tooltip: {
    id: 'Pricing.experimentTooltipCopy.CreateSurveyLimitTooltipDescription',
    defaultMessage: NUM_SURVEYS_FORMS_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.CreateSurveyLimitTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_database_response_view_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltip',
    defaultMessage: 'Database response view',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_database_response_view_tooltip: {
    id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltipDescription',
    defaultMessage: 'View and manage all of your responses in one table.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_question_types_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.QuestionTypesTooltip',
    defaultMessage: QUESTION_TYPES,
    desc: {
      id: 'Pricing.experimentTooltipCopy.QuestionTypesTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_question_types_tooltip: {
    id: 'Pricing.experimentTooltipCopy.QuestionTypesTooltipDescription',
    defaultMessage: QUESTION_TYPES_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.QuestionTypesTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_forms_question_types_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltip',
    defaultMessage: QUESTION_TYPES,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_forms_question_types_tooltip: {
    id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltipDescription',
    defaultMessage: QUESTION_TYPES_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_website_embed_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltip',
    defaultMessage: 'Website embed',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_website_embed_tooltip: {
    id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltipDescription',
    defaultMessage: 'Seamlessly embed a form or survey on your website, or present them in a pop-up message.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_zapier_integrations_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.ZapierTooltip',
    defaultMessage: '500+ integrations with Zapier',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ZapierTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_zapier_integrations_tooltip: {
    id: 'Pricing.experimentTooltipCopy.ZapierTooltipDescription',
    defaultMessage:
      'Zapier lets you connect SurveyMonkey with thousands of the most popular apps, so you can automate your workflow and have more time for what matters most—no code required.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ZapierTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_analysis_filter_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AnalysisFilterTooltip',
    defaultMessage: FILTER_COMPARE,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalysisFilterTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_analysis_filter_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AnalysisFilterTooltipDescription',
    defaultMessage:
      'Filter your results and compare how different groups answered the questions in your survey. Segment your data to uncover trends and correlations.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalysisFilterTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_forms_analysis_filter_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.FormsAnalysisFilterTooltip',
    defaultMessage: FILTER_COMPARE,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsAnalysisFilterTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_forms_analysis_filter_tooltip: {
    id: 'Pricing.experimentTooltipCopy.FormsAnalysisFilterTooltipDescription',
    defaultMessage:
      'Filter your results and compare how different groups answered the questions in your survey or form. Segment your data to uncover trends and correlations.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsAnalysisFilterTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_survey_create_limit_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SurveysFormsTooltip',
    defaultMessage: NUM_SURVEYS_FORMS,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveysFormsTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_survey_create_limit_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SurveysFormsTooltipDescription',
    defaultMessage: NUM_SURVEYS_FORMS_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveysFormsTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_recurring_surveys_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltip',
    defaultMessage: 'Recurring forms & surveys',
    desc: {
      id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_recurring_surveys_tooltip: {
    id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltipDescription',
    defaultMessage: `Recurring forms & surveys make it easy to collect new results for the same forms & survey on a weekly, monthly, or quarterly basis. We'll email you new survey links when they're ready, so all you need to do is copy each new link and send it to respondents. Filter your results by each occurrence to see how people responded differently over time.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_unlimited_questions_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltip',
    defaultMessage: QUESTIONS_PER_SURVEY_FORMS,
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_unlimited_questions_tooltip: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltipDescription',
    defaultMessage: QUESTIONS_PER_SURVEY_FORMS_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_forms_unlimited_questions_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.FormsUnlimitedQuestionsTooltip',
    defaultMessage: QUESTIONS_PER_SURVEY_FORMS,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsUnlimitedQuestionsTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_forms_unlimited_questions_tooltip: {
    id: 'Pricing.experimentTooltipCopy.FormsUnlimitedQuestionsTooltipDescription',
    defaultMessage: QUESTIONS_PER_SURVEY_FORMS_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsUnlimitedQuestionsTooltipDescription',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_survey_branding_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipHeading',
    defaultMessage: 'Customized surveys',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_survey_branding_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltip',
    defaultMessage: `Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  best_worst_qt_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.BestWorstQtTooltipHeading',
    defaultMessage: 'Best worst scale',
    desc: {
      id: 'Pricing.experimentTooltipCopy.BestWorstQtTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  best_worst_qt_tooltip: {
    id: 'Pricing.experimentTooltipCopy.BestWorstQtTooltip',
    defaultMessage:
      'Find out what people like most, what they like least, and what they think of everything in between.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.BestWorstQtTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_multilingual_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.MultilingualTooltipHeading',
    defaultMessage: 'Multilingual surveys and forms',
    desc: {
      id: 'Pricing.experimentTooltipCopy.MultilingualTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_multilingual_tooltip: {
    id: 'Pricing.experimentTooltipCopy.MultilingualTooltip',
    defaultMessage: `Reach everyone in the language they're most comfortable with. Add multiple languages to a single survey or form, and analyze all your results together in one data set.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.MultilingualTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_analyze_sentiment_enabled_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeSentimentEnabledTooltip',
    defaultMessage: SENTIMENT_ANALYSIS_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeSentimentEnabledTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_analyze_sentiment_enabled_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeSentimentEnabledTooltipHeading',
    defaultMessage: SENTIMENT_ANALYSIS,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeSentimentEnabledTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_phone_support_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.PhoneSupportTooltipHeading',
    defaultMessage: 'Phone support',
    desc: {
      id: 'Pricing.experimentTooltipCopy.PhoneSupportTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_phone_support_tooltip: {
    id: 'Pricing.experimentTooltipCopy.PhoneSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.PhoneSupportTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_survey_branding_t2_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipHeadingT2',
    defaultMessage: 'Customized surveys and forms',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipHeadingT2',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_survey_branding_t2_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipT2',
    defaultMessage: `Customize your survey or form's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's url. For example: www.surveymonkey.com/s/your-survey`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyBrandingTooltipT2',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_statistical_significance_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.StatisticalSignificanceTooltipHeading',
    defaultMessage: 'A/B test question type & statistical significance analysis',
    desc: {
      id: 'Pricing.experimentTooltipCopy.StatisticalSignificanceTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_statistical_significance_tooltip: {
    id: 'Pricing.experimentTooltipCopy.StatisticalSignificanceTooltip',
    defaultMessage:
      'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text. Use statistical significance analysis to see if there are statistically significant difference between response groups.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.StatisticalSignificanceTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_data_exports_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipHeading',
    defaultMessage: 'Data exports',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_data_exports_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltip',
    defaultMessage: `Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export SPSS for Advantage and Premier members.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_analyze_export_spss_enabled_t2_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipHeadingT2',
    defaultMessage: 'Data exports',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipHeadingT2',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_analyze_export_spss_enabled_t2_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipT2',
    defaultMessage: `Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export SPSS for Advantage and Premier members.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportSpssEnabledTooltipT2',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_survey_quiz_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.EssentialQuestionTypesTooltipHeading',
    defaultMessage: QUESTION_TYPES,
    desc: {
      id: 'Pricing.experimentTooltipCopy.EssentialQuestionTypesTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_survey_quiz_tooltip: {
    id: 'Pricing.experimentTooltipCopy.EssentialQuestionTypesTooltip',
    defaultMessage: `Pick from 25+ question types to ensure you get exactly the information you need. With the forms plan you'll have what you need to collect contact information, online orders, and more`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.EssentialQuestionTypesTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_unlimited_analysis_filters_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedAnalysisFiltersTooltipHeading',
    defaultMessage: FILTER_COMPARE,
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedAnalysisFiltersTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_unlimited_analysis_filters_tooltip: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedAnalysisFiltersTooltip',
    defaultMessage:
      'Filter your results and compare how different groups answered the questions in your survey or form. Segment your data to uncover trend and correlations.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedAnalysisFiltersTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_payment_qt_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.PaymentQTTooltipHeading',
    defaultMessage: 'Accept payments',
    desc: {
      id: 'Pricing.experimentTooltipCopy.PaymentQTTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_payment_qt_tooltip: {
    id: 'Pricing.experimentTooltipCopy.PaymentQTTooltip',
    defaultMessage:
      'Accept credit card payments from respondents in your surveys or forms with our Stripe integration.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.PaymentQTTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_file_upload_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.FileUploadTooltipHeading',
    defaultMessage: 'File upload',
    desc: {
      id: 'Pricing.experimentTooltipCopy.FileUploadTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_file_upload_tooltip: {
    id: 'Pricing.experimentTooltipCopy.FileUploadTooltip',
    defaultMessage:
      'Allow respondents to upload a file as part of their responses. You can add up to 20 file upload questions per form or survey.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.FileUploadTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_skip_logic_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SkipLogicTooltipHeading',
    defaultMessage: 'Customized survey experience',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SkipLogicTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_skip_logic_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SkipLogicTooltip',
    defaultMessage: `Get more ways to personalize each respondents experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert text from a question into another question on a later page in the survey.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SkipLogicTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_text_analysis_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltipHeading',
    defaultMessage: 'Text analysis',
    desc: {
      id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_text_analysis_tooltip: {
    id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltip',
    defaultMessage:
      'Use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_quizzes_pro_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.QuizzesProTooltipHeading',
    defaultMessage: 'Quizzes',
    desc: {
      id: 'Pricing.experimentTooltipCopy.QuizzesProTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_quizzes_pro_tooltip: {
    id: 'Pricing.experimentTooltipCopy.QuizzesProTooltip',
    defaultMessage: `Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.QuizzesProTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },

  grow_2529_collector_white_label_enabled_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.WhiteLabelTooltipHeading',
    defaultMessage: 'White label surveys',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WhiteLabelTooltipHeading',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_collector_white_label_enabled_tooltip: {
    id: 'Pricing.experimentTooltipCopy.WhiteLabelTooltip',
    defaultMessage:
      'Completely customize and brand your surveys and forms. Remove the SurveyMonkey footer, change the domain of your link to research.net, and redirect respondents to your site upon completion.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WhiteLabelTooltip',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TOOLTIPS} description ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
});

export default experimentTooltipCopy;
